export default "__VITE_ASSET__aGktpCF$__"